import axios from './index';

/**
 * APIs（导出记录，接口尚未完全就绪）
 */
export function exports(params: ExportParams) {
    return axios<PageResType<ExportResponse>>('/v1/export/records', {
        method: 'get',
        params,
    });
}

/**
 * Types
 */
import { PageResType } from '@/typings/common';

export type ExportParams = {
    operator_account_id?: string;
    create_start?: string;
    create_end?: string;
    page?: number | string;
    limit?: number | string;
    order_by?: string;
    order_sort?: 'asc' | 'desc';
};

export type ExportResponse = {
    id?: string;
    operator_account?: {
        id: string;
        name: string;
    };
    detail?: Record<string, any>;
    origin?: string;
    download_url?: string;
    status: 'pending' | 'completed' | 'failed';
    created_at: string;
};
